import { useRequest, useView } from '@10000/react'
import { SettingsForm } from '../'
import { Boolean } from '../../forms'
import { Box } from '../../widgets'

export const Preferences = ({ goBackToSettingsMenu }) => {
  const request = useRequest('tenant')
  const { user: { preferences } } = useView('tenant')
  const { guides, tutorial, presenterParticipates, consensus } = preferences || { guides: true, tutorial: true, presenterParticipates: true, consensus: true }

  const savePreferences = preferences => request('userPreferencesUpdated', { preferences })

  return (
    <SettingsForm
      onSubmit={savePreferences}
      values={{ guides, tutorial, presenterParticipates, consensus }}
      title="Preferences"
      backButtonMobileOnly
      onBackButtonClick={goBackToSettingsMenu}
    >
      <Box column fullWidth gap={16} pt={16}>
        <Boolean name="guides" title="Play with guides" />
        <Boolean name="tutorial" title="Start with tutorial" />
        <Boolean name="presenterParticipates" title="Host participates" />
        <Boolean name="consensus" title="Consensus mode" />
      </Box>
    </SettingsForm>
  )
}